import { render, staticRenderFns } from "./index.vue?vue&type=template&id=228f836f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=228f836f&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=228f836f&prod&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&id=228f836f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f836f",
  null
  
)

export default component.exports